import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    const delay = this.timeoutValue || 4000
    this.element.style.maxHeight = `${this.element.scrollHeight}px`
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "scale-95")
      this.element.classList.add("opacity-100", "scale-100")
    })
    this.timer = setTimeout(() => this.dismiss(), delay)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  dismiss() {
    if (this.timer) clearTimeout(this.timer)
    this.element.classList.add("opacity-0")
    this.element.style.maxHeight = "0px"
    this.element.style.marginTop = "0px"
    this.element.style.paddingTop = "0px"
    this.element.style.paddingBottom = "0px"
    const removeNow = () => this.element.remove()
    this.element.addEventListener("transitionend", removeNow, { once: true })
    setTimeout(removeNow, 450)
  }
}
